export default __webpack_public_path__ + "static/case-5-hero-285faf85946bb407bd9e1c25aadc2366.png";